import { EmptyState } from '@/components/EmptyState';

export function Settings() {
  return (
    <EmptyState
      title="Settings"
      description="No settings yet. Ops configuration will land in a later issue."
    />
  );
}
